import { RESET_STATE, SET_IS_IMPORTED_FILE_LOADING } from './actions';

export const initialState = {
	isImportFileLoading: false,
};

const ordersImportsModalReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case SET_IS_IMPORTED_FILE_LOADING:
			return {
				...state,
				isImportFileLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default ordersImportsModalReducer;
